// SHOPIFY FORMS EMBED TRACKING
document.addEventListener('DOMContentLoaded', function () {
  function normalizeFormName(name) {
    return name.trim().replace(/\s+/g, '-').toLowerCase();
  }

  function addSubmissionEventToDataLayer(formName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'CFsubmit-' + normalizeFormName(formName)
    });
  }
  function isStandardFormValid(form) {
    return form.checkValidity();
  }

  function findSuccessElement(formElement) {
    return (
      formElement.querySelector('.message.success') ||
      formElement.querySelector('[data-testid="banner-success"]') ||
      formElement.querySelector('[data-current-step="success"]')
    );
  }

  function isElementVisible(element) {
    if (!element) {
      return false;
    }
    const style = getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0'
    );
  }

  function startSuccessObserver(formElement, formName) {
    if (!formElement || !formName) {
      return;
    }
    const successElement = findSuccessElement(formElement);
    if (isElementVisible(successElement)) {
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      const successElement = findSuccessElement(formElement);

      if (isElementVisible(successElement)) {
        addSubmissionEventToDataLayer(formName);
        observer.disconnect();
      }
    });

    observer.observe(formElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  }

  function getFormName(element) {
    const parentWithDataLayerName = element.closest('[data-layer-name]');
    if (parentWithDataLayerName) {
      return parentWithDataLayerName.getAttribute('data-layer-name');
    }

    if (element.hasAttribute('data-layer-name')) {
      return element.getAttribute('data-layer-name');
    }

    return false;
  }

  // SHOIFY FORM TRACKING
  const trackedForms = new WeakSet();
  function attachShopifyFormListener(shopifyFormElement) {
    if (trackedForms.has(shopifyFormElement)) {
      return;
    }

    const formName = getFormName(shopifyFormElement);
    if (!formName) {
      return;
    }

    trackedForms.add(shopifyFormElement);

    const shadowRoot = shopifyFormElement.shadowRoot;

    if (shadowRoot) {
      const form = shadowRoot.querySelector('form');
      if (form) {
        form.addEventListener(
          'submit',
          function () {
            startSuccessObserver(shadowRoot, formName);
          },
          { once: true }
        );
      }
    } else {
      shopifyFormElement.addEventListener(
        'click',
        function (event) {
          const target = event.target;
          if (
            target &&
            (target.type === 'submit' ||
              target.getAttribute('data-testid') === 'btn-form-submit')
          ) {
            const form = target.closest('form');
            if (form) {
              startSuccessObserver(form, formName);
            }
          }
        },
        { once: true, capture: true }
      );
    }
  }

  // GENERIC FORM TRACKING
  const trackedGenericForms = new WeakSet();
  function attachGenericFormListener(form) {
    if (trackedGenericForms.has(form)) {
      return;
    }

    const formName = getFormName(form);
    if (!formName) {
      return;
    }

    trackedGenericForms.add(form);
    if (form.closest('.globo-form')) {
      form.addEventListener(
        'submit',
        function () {
          startSuccessObserver(form, formName);
          return;
        },
        { once: true }
      );
    } else {
      form.addEventListener('submit', function () {
        if (isStandardFormValid(form)) {
          addSubmissionEventToDataLayer(formName);
        }
      });
    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (
            node.tagName &&
            node.tagName.toLowerCase() === 'shopify-forms-embed'
          ) {
            attachShopifyFormListener(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll('form').forEach(function (form) {
              attachGenericFormListener(form);
            });
          }
        }
      });
    });
  });

  document.querySelectorAll('.shopify-app-block').forEach(function (block) {
    observer.observe(block, {
      childList: true,
      subtree: true
    });
  });

  document.querySelectorAll('form[data-layer-name]').forEach(function (form) {
    attachGenericFormListener(form);
  });
});
